import { render, staticRenderFns } from "./BillingService.vue?vue&type=template&id=70b8bb9e&"
import script from "./BillingService.vue?vue&type=script&lang=js&"
export * from "./BillingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports